import React from 'react';
import useFetchData from '../crud/useFetchData';
import GrupoEmpresasUI from '../App/GrupoEmpresas/GrupoEmpresasUI'
import {proto,url} from '../Helpers/api';

const Page_GrupoEmpresas = props => {
  const {
    isLoading,
    isFinished,
    error,
    data=[],
    refresh,
  } = useFetchData(`${proto}://${url}/grupos/mytest/list`)
  // } = useFetchData(`${proto}://${url}/main/mytest/list`)
  if (isLoading) return <div>Carregando dados...</div>;
  if (error) return <div>Erro! {error}</div>;
  if (!isFinished) return null
  return (
    <GrupoEmpresasUI
      data={data}
      refresh={refresh}
    />
  )
}

export default Page_GrupoEmpresas;
